// src/contexts/WallofLoveContext.js
import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';

const WallofLoveContext = createContext();
const baseUrl = process.env.REACT_APP_API_URL;
const endpointGet = `${baseUrl}/reviews`;
const endpointPost = `${baseUrl}/reviews`;

export const WallofLoveProvider = ({ children }) => {
  const [reviews, setReviews] = useState([]);
  const [loadingReviews, setLoadingReviews] = useState(false);
  const [errorReviews, setErrorReviews] = useState(null);
  const [postSuccess, setPostSuccess] = useState(false);
  const [postError, setPostError] = useState(null);

  // GET - Fetch all reviews
  const fetchReviews = async () => {
    setLoadingReviews(true);
    setErrorReviews(null);
    //console.log("[WallofLoveContext] URL appelée :", endpointGet);
    try {
      const response = await axios.get(endpointGet);
      let parsed = [];
      const body = response?.data?.body;
      if (body) {
        try {
          parsed = JSON.parse(body);
        } catch (e) {
          console.error("[WallofLoveContext] Erreur de parsing JSON :", e, "body reçu :", body);
          throw new Error("Erreur lors du parsing JSON des reviews.");
        }
      } else if (Array.isArray(response.data)) {
        parsed = response.data;
      } else {
        console.warn("[WallofLoveContext] Réponse backend inattendue :", response.data);
        throw new Error("Donnée de réponse reviews vide ou mal formatée.");
      }
      setReviews(parsed);
      //console.log('[WallofLoveContext] Reviews après parsing :', parsed);
    } catch (err) {
      console.error('[WallofLoveContext] Failed to fetch reviews:', err);
      setErrorReviews(err.message || 'Erreur inconnue');
    } finally {
      setLoadingReviews(false);
    }
  };

  // POST - Submit a new review
const submitReview = async (reviewData) => {
  setPostSuccess(false);
  setPostError(null);

  //console.log("📤 [submitReview] Début de soumission");
  //console.log("🌐 [submitReview] URL endpoint :", endpointPost);
  //console.log("📦 [submitReview] Payload :", reviewData);

  try {
    const response = await axios.post(
      endpointPost,
      JSON.stringify(reviewData),
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

    //console.log("✅ [submitReview] Réponse brute :", response);

    let parsed = {};
    const body = response?.data?.body;

    if (body) {
      try {
        parsed = JSON.parse(body);
        //console.log("✅ [submitReview] Réponse parsée :", parsed);
      } catch (e) {
        console.error("❌ [submitReview] Erreur de parsing JSON POST :", e);
        console.error("📨 Body reçu non parsable :", body);
        throw new Error("Erreur lors du parsing JSON de la réponse du post review.");
      }
    } else if (typeof response.data === "object" && response.data !== null) {
      parsed = response.data;
      //console.log("✅ [submitReview] Réponse déjà objet :", parsed);
    } else {
      console.warn("⚠️ [submitReview] Réponse backend inattendue :", response.data);
      throw new Error("Donnée de réponse vide ou mal formatée.");
    }

    setPostSuccess(true);
    return parsed;

  } catch (err) {
    console.error("❌ [submitReview] Erreur axios :", err);
    if (err.response) {
      console.error("📡 Status:", err.response.status);
      console.error("📡 Headers:", err.response.headers);
      console.error("📡 Body:", err.response.data);
    }
    setPostError(err.message || 'Erreur inconnue');
    throw err;
  }
};


  return (
    <WallofLoveContext.Provider
      value={{
        reviews,
        fetchReviews,
        loadingReviews,
        errorReviews,
        submitReview,
        postSuccess,
        postError,
      }}
    >
      {children}
    </WallofLoveContext.Provider>
  );
};

export const useWallofLoveContext = () => useContext(WallofLoveContext);
